import styled from 'styled-components';
import { BodyText, Button, HeadingText } from '@unmind/design-system';
import { rem } from 'polished';

export const PageContainer = styled.div`
  min-height: 100vh;
  min-width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${rem(24)};
  gap: ${rem(12)};
`;

export const ContentContainer = styled.div`
  width: 100%;
  max-width: ${rem(800)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(40)};
  margin-top: auto;
  margin-bottom: auto;
`;

export const DisclaimerHeaderText = styled(HeadingText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize24],
  weight: theme.typography.fontWeights.semiBold,
}))`
  text-align: center;
`;

export const AboutContainer = styled.div`
  width: 100%;
  border-radius: ${rem(12)};
  background-color: ${({ theme }) => theme.colors.background.secondary};
  padding: ${rem(16)};
`;

export const DisclaimerButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
`;

export const AcknowledgeButton = styled(Button).attrs(() => ({
  variant: 'primary',
}))`
  width: 100%;
`;

export const AcknowledgeButtonText = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  color: theme.colors.text.inverse,
}))`
  text-align: center;
`;

export const GoBackButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  min-height: ${rem(20)};
  padding: ${rem(12)} ${rem(20)};
  border-radius: ${rem(20)};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.secondary};
  }
`;

export const GoBackButtonText = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  color: theme.colors.text.primary,
}))`
  text-decoration-line: underline;
  text-decoration-color: ${({ theme }) => theme.colors.text.primary};
  display: inline-block;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HelpButtonContainer = styled.div`
  margin-bottom: ${rem(12)};
  margin-left: auto;
`;
